import axios, { InternalAxiosRequestConfig } from 'axios';
import { CAMPANHA_URL } from 'domain/infra/data/env';
import { campanhaTokenManager } from './campanhaTokenManager';

let isRegistered = false;

export function registerCampanhaAuthInterceptor(): void {
    if (isRegistered) {
        return;
    }

    axios.interceptors.request.use(async function campanhaTokenInterceptor(config: InternalAxiosRequestConfig) {
        const url = config.url || '';

        if (url.startsWith(CAMPANHA_URL) && !url.includes('/oauth2/token')) {
            const token = await campanhaTokenManager.GetCampanhaToken();
            if (token) {
                config.headers.Authorization = token;
            }
        }

        return config;
    });

    isRegistered = true;
}
